// OFFSET is required because our RBC sticky header
// imposes some form of invisible margin, but it does
// still take up space in the scroll container.
const SCROLL_OFFSET = 100;

export const scrollIntoView = ({
  scrollContainer,
  timeSlotRef
}: {
  scrollContainer: Element;
  timeSlotRef: Element;
}) => {
  if (!timeSlotRef || !scrollContainer) return; //sanity

  const timeSlotBounds = timeSlotRef.getBoundingClientRect();
  const containerBounds = scrollContainer.getBoundingClientRect();

  const timeSlotTopPosition =
    scrollContainer.scrollTop + (timeSlotBounds.top - containerBounds.top);
  const timeSlotBottomPosition = timeSlotTopPosition + timeSlotBounds.height;

  const viewTop = scrollContainer.scrollTop + SCROLL_OFFSET;
  const viewBottom = scrollContainer.scrollTop + scrollContainer.clientHeight;

  const alreadyVisible =
    timeSlotTopPosition >= viewTop && timeSlotBottomPosition <= viewBottom;
  if (alreadyVisible) {
    return;
  }

  const calcTop =
    timeSlotTopPosition < viewTop
      ? timeSlotTopPosition - SCROLL_OFFSET
      : timeSlotBottomPosition - scrollContainer.clientHeight;

  const maxTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;
  const newTop = Math.max(0, Math.min(calcTop, maxTop));

  scrollContainer.scrollTo({ top: newTop, behavior: 'smooth' });
};
